import { InjectionToken } from '@angular/core';
import { Config } from '@modeso/aumico-lib-core-fe';

export interface AumicoTemplatesConfig extends Config {
    apiGateway: string;
    serviceId: string;
    // if true, the service is used in the prototyping framework
    // so that all calls respond with 200 success and predefined data, if not otherwise defined
    prototype?: boolean;
}

export const AumicoTemplatesConfigService = new InjectionToken<AumicoTemplatesConfig>('Config');
